<template>
	<form-field-wrap
		class="b-form__calendar"
		:field-props="fieldProps"
		:is-error="isError"
		:field-value="fieldValue"
		:is-switch="isSwitch"
		:input-focus="inputFocus"
		:with-label="false"
	>
		<div class="b-form__calendarItem b-form__calendarItem_date date-control b-form__calendarItem_date_year">
			<input
				type="text"
				data-input
				autocomplete="off"
				:name="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
				:class="[inputClass, (fieldValue || inputFocus) ? 'is-fill' : '']"
				v-validate="rules"
				:data-vv-as="fieldProps.TITLE"
				:value="fieldValue"
				:id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
				:disabled="disable"
				:placeholder="fieldProps.PLACEHOLDER"
				@input="changeValue"
				@focus="labelSwitch('focus')"
				@blur="labelSwitch"
			>
			<span class="select_toggle b-form__calendarToggle" data-toggle>
				<i class="icon icon--arrow-down"></i>
			</span>
		</div>
	</form-field-wrap>
</template>
<script>
export default {
	name: "CitrusAdminDate",
	props: {
		format: {
			type: String,
			default: "d.m.Y H:i",
		},
	},
	data() {
		return {
			inputFocus: false,
			error: false,
			dateValue: "",
			timeValue: "",
			inputValue: "",
			dateOptions: {},
			timeOptions: {},
			defaultOptions: {
				locale: "ru",
				dateFormat: "d.m.Y H:i",
				defaultDate: "",
				wrap: true,
				enableTime: true,
				time_24hr: true,
				minuteIncrement: 1,
				allowInput: true,
			}
		}
	}
}
</script>